module.exports = __webpack_public_path__ + "static/img/multimedia2.9634f927.png";